import {reducer} from '../helpers'

import * as lookbuilderActions from '../../actions/lookbuilder'

import {LookbuilderViews} from '../../store/lookbuilder/enums'

/**
 * Determines which direction we are navigating based on the previous view and
 * currently requested view.
 *
 * @param {Object} state
 * @param {String} state.currentStep The current view we are on
 * @param {Object} action
 * @param {Object} action.payload
 * @param {String} action.payload.view The view we are navigating to
 * @return {Object}
 */
function handleNavigateToView(state, action) {
  let isNavigatingForward = true

  if (state.currentStep === LookbuilderViews.detail) {
    isNavigatingForward = false
  } else if (state.currentStep === LookbuilderViews.category) {
    isNavigatingForward = action.payload.view === LookbuilderViews.detail
  }

  return {
    currentStep: action.payload.view,
    isNavigatingForward,
  }
}

const initialState = {
  currentStep: LookbuilderViews.planner,
  isNavigatingForward: true,
  previousStep: '',
}

export default reducer(initialState, (state, action) => {
  switch (action.type) {
    case lookbuilderActions.RESET_LOOKBUILDER_LOOK:
      return {...initialState}
    case lookbuilderActions.NAVIGATE_TO_VIEW:
      return {
        ...handleNavigateToView(state, action),
        previousStep: state.currentStep,
      }
    case lookbuilderActions.OPEN_LOOKBUILDER_PLANNER_VIEW:
      return {
        currentStep: LookbuilderViews.planner,
        isNavigatingForward: false,
        previousStep: state.currentStep,
      }
    default:
      return null
  }
})
